import { ReactNode, useCallback, useMemo, useState } from 'react'
import { OrderSource, OrderSourceContext, OrderSourceContextType } from './OrderSourceContext'

export function OrderSourceProvider({ children }: { children: ReactNode }) {
    const [orderSource, setOrderSourceState] = useState<OrderSource>({
        orderFrom: null,
        orderEntryPoint: null,
    })

    const setOrderSource = useCallback(
        (orderFrom: OrderSource['orderFrom'], orderEntryPoint: OrderSource['orderEntryPoint']) => {
            setOrderSourceState({ orderFrom, orderEntryPoint })
        },
        [],
    )

    const clearOrderSource = useCallback(() => {
        setOrderSourceState({ orderFrom: null, orderEntryPoint: null })
    }, [])

    const value = useMemo<OrderSourceContextType>(
        () => ({
            orderSource,
            setOrderSource,
            clearOrderSource,
        }),
        [orderSource, setOrderSource, clearOrderSource],
    )

    return <OrderSourceContext.Provider value={value}>{children}</OrderSourceContext.Provider>
}
